import _ from 'lodash'

import { Option } from 'constants/models'
import { createTypeFromEnumValues } from 'utils/typescript'

import i18n from 'translations'

export enum FREQUENCIES {
  AS_NEEDED = 'as_needed',
  DAILY = 'daily',
}

export const FREQUENCY_LABELS = {
  [FREQUENCIES.AS_NEEDED]: i18n.t('services:MedicationForm:Frequency:asNeeded'),
  [FREQUENCIES.DAILY]: i18n.t('services:MedicationForm:Frequency:daily'),
}

export const FREQUENCY_OPTIONS = [
  {
    label: FREQUENCY_LABELS[FREQUENCIES.DAILY],
    value: FREQUENCIES.DAILY,
  },
  {
    label: FREQUENCY_LABELS[FREQUENCIES.AS_NEEDED],
    value: FREQUENCIES.AS_NEEDED,
  },
]

export enum BEFORE_AFTER_EATING {
  AFTER_EATING = 'after_eating',
  BEFORE_EATING = 'before_eating',
  NOT_APPLICABLE = 'not_applicable',
  WITH_FOOD = 'with_food',
}

export const BEFORE_AFTER_EATING_LABELS = {
  [BEFORE_AFTER_EATING.BEFORE_EATING]: i18n.t('services:MedicationForm:BeforeAfterEating:beforeEating'),
  [BEFORE_AFTER_EATING.WITH_FOOD]: i18n.t('services:MedicationForm:BeforeAfterEating:withFood'),
  [BEFORE_AFTER_EATING.AFTER_EATING]: i18n.t('services:MedicationForm:BeforeAfterEating:afterEating'),
  [BEFORE_AFTER_EATING.NOT_APPLICABLE]: i18n.t('services:MedicationForm:BeforeAfterEating:notApplicable'),
}

export const BEFORE_AFTER_EATING_OPTIONS = [
  {
    label: BEFORE_AFTER_EATING_LABELS[BEFORE_AFTER_EATING.BEFORE_EATING],
    value: BEFORE_AFTER_EATING.BEFORE_EATING,
  },
  {
    label: BEFORE_AFTER_EATING_LABELS[BEFORE_AFTER_EATING.WITH_FOOD],
    value: BEFORE_AFTER_EATING.WITH_FOOD,
  },
  {
    label: BEFORE_AFTER_EATING_LABELS[BEFORE_AFTER_EATING.AFTER_EATING],
    value: BEFORE_AFTER_EATING.AFTER_EATING,
  },
  {
    label: BEFORE_AFTER_EATING_LABELS[BEFORE_AFTER_EATING.NOT_APPLICABLE],
    value: BEFORE_AFTER_EATING.NOT_APPLICABLE,
  },
]

export enum MEDICATION_FORM_STATUSES {
  ACTIVE = 'active',
  DRAFT = 'draft',
  EXPIRED = 'medication_expired',
  NEED_REVIEW = 'need_review',
  PAST = 'past',
  UPCOMING = 'upcoming'
}

export const MEDICATION_FORM_STATUS_LABELS = {
  [MEDICATION_FORM_STATUSES.ACTIVE]: i18n.t('global:Active'),
  [MEDICATION_FORM_STATUSES.DRAFT]: _.upperFirst(i18n.t('global:draft')),
  [MEDICATION_FORM_STATUSES.EXPIRED]: i18n.t('services:MedicationForm:Status:medicationExpired'),
  [MEDICATION_FORM_STATUSES.PAST]: i18n.t('global:Past'),
  [MEDICATION_FORM_STATUSES.UPCOMING]: _.upperFirst(i18n.t('global:upcoming')),
  [MEDICATION_FORM_STATUSES.NEED_REVIEW]: i18n.t('services:MedicationForm:Status:needReview'),
}

export const MEDICATION_FORM_STATUS_OPTIONS = [
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.ACTIVE],
    value: MEDICATION_FORM_STATUSES.ACTIVE,
  },
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.DRAFT],
    value: MEDICATION_FORM_STATUSES.DRAFT,
  },
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.EXPIRED],
    value: MEDICATION_FORM_STATUSES.EXPIRED,
  },
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.PAST],
    value: MEDICATION_FORM_STATUSES.PAST,
  },
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.UPCOMING],
    value: MEDICATION_FORM_STATUSES.UPCOMING,
  },
  {
    label: MEDICATION_FORM_STATUS_LABELS[MEDICATION_FORM_STATUSES.NEED_REVIEW],
    value: MEDICATION_FORM_STATUSES.NEED_REVIEW,
  },
]

export enum STORED_ON_SITE {
  ON_SITE = 'on_site',
  PROVIDED_BY_PARENTS = 'provided_by_parents',
}

export const STORED_ON_SITE_LABELS = {
  [STORED_ON_SITE.ON_SITE]: i18n.t('module:Safeguarding:MedicationForm:Filters:onSite'),
  [STORED_ON_SITE.PROVIDED_BY_PARENTS]: i18n.t('module:Safeguarding:MedicationForm:Filters:providedByParents'),
}

export const STORED_ON_SITE_OPTIONS = [
  {
    label: STORED_ON_SITE_LABELS[STORED_ON_SITE.ON_SITE],
    value: STORED_ON_SITE.ON_SITE,
  },
  {
    label: STORED_ON_SITE_LABELS[STORED_ON_SITE.PROVIDED_BY_PARENTS],
    value: STORED_ON_SITE.PROVIDED_BY_PARENTS,
  },
]

export const MF_SIGNATURE_TYPES = {
  PARENT: 'parent',
  STAFF: 'staff',
  WITNESS: 'witness',
}

export enum MEDICATION_DETAILS_TYPE {
  EMERGENCY = 'emergency',
  MEDICATION_FORM = 'medicationForm',
}

export type MedicationFormStatusOptionProps = Option<createTypeFromEnumValues<MEDICATION_FORM_STATUSES>>
